export const OfficeLiveEquipmentState = {
	url: '/live-equipment',
	title: 'Office Live Equipment',
	template: '<office-live-equipment-page></office-live-equipment-page>',
	lazyLoad: $transition$ => {
		const $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
		const $log = $transition$.injector().get('$log');
		return import(
			/* webpackChunkName: "officeLiveEquipmentPageMod" */
			'@Containers/office-live-equipment-page/office-live-equipment.cmp.js'
		)
			.then(res => $ocLazyLoad.load({name: res.default}))
			.catch(err => $log.error(err));
	},
};
